<template>
  <entry-message-reservation-to-applicant
    id="message-reservation-canceled"
    :message-reservation="messageReservation"
    :entry-id="entryId"
    :reservation-status-label="cancelReasonText"
    :use-accordion="true"
    :is-withdraw="isWithdraw"
    @remove="remove"
    @setMessage="setMessage"
    @downloadFile="downloadFile"
  />
</template>

<script>
import * as definition from '@/lib/labelValueMappings'
import EntryMessageReservationToApplicant from '@/components/molecules/EntryMessageReservationToApplicant'
import { downloadFile } from '@/lib/download'

export default {
  components: {
    EntryMessageReservationToApplicant
  },
  props: {
    messageReservation: {
      type: Object,
      required: true
    },
    entryId: {
      type: Number,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    canceledId () {
      return this.messageReservation.entryMailReservationCanceledId
    },
    cancelReasonText () {
      return definition.entryMessageReservationCancelReason
        .find(item => item.id === this.messageReservation.cancelReasonId)
        .label
    }
  },
  methods: {
    remove () {
      this.$http.secured.delete(`/entry/message/send/entries/${this.entryId}/message/canceled_reservation`).then(() => {
        this.$toasted.global.success({ message: 'メッセージを削除しました' })
        this.$emit('fetchAllMessage')
      })
    },
    setMessage () {
      const message = { body: this.messageReservation.message.body, subject: this.messageReservation.message.subject }
      this.$emit('setMessage', { message: message })
    },
    downloadFile (fileId, fileName) {
      downloadFile(`/entry/view/entries/${this.entryId}/message/canceled_reservations/${this.canceledId}/files/${fileId}/download`, fileName)
    }
  }
}
</script>
